import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Panel } from '../../../common/panel'
import { formatText } from '../../../helpers/value'
import { LabelPanel } from '../common/LabelPanel'
import { RightPanel } from '../common/RightPanel'
import classes from './index.module.scss'

export const ChangePeriod = ({ data, detailKey }) => {
  const detailData = data[detailKey]

  return (
    <Panel
      renderLabel={() => <LabelPanel data={data} detailData={detailData} />}
      renderRightHeader={() => <RightPanel data={data} detailKey={detailKey} />}
    >
      <Element className={classes.description} style={{ fontSize: 14 }}>
        {formatText(detailData?.description)}
      </Element>
      <Element
        className={classes.content}
        style={{ fontSize: 14, color: '#3A414B' }}
      >
        <div>
          <Translate
            value="alertDetail.FISCAL_YEAR"
            className="textUppercase"
          />
        </div>
        <Element
          className={classes.contentItem}
          style={{ backgroundColor: '#F3F3F3' }}
        >
          <Translate value="alertDetail.PREVIOUS" className="textUppercase" />
          <div className={classes.mt12}>{formatText(detailData?.previous)}</div>
        </Element>
        <Element
          className={classes.contentItem}
          style={{ backgroundColor: '#F3F3F3' }}
        >
          <Translate value="alertDetail.CURRENT" className="textUppercase" />
          <div className={classes.mt12}>{formatText(detailData?.current)}</div>
        </Element>
      </Element>
    </Panel>
  )
}
